export default "__VITE_ASSET__Do3R_fRE__"